/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataImportRowChangeType } from './DataImportRowChangeType';
import {
    DataImportRowChangeTypeFromJSON,
    DataImportRowChangeTypeFromJSONTyped,
    DataImportRowChangeTypeToJSON,
} from './DataImportRowChangeType';

/**
 * 
 * @export
 * @interface DataImportRow
 */
export interface DataImportRow {
    /**
     * 
     * @type {string}
     * @memberof DataImportRow
     */
    error?: string | null;
    /**
     * 
     * @type {any}
     * @memberof DataImportRow
     */
    rawData: any | null;
    /**
     * 
     * @type {DataImportRowChangeType}
     * @memberof DataImportRow
     */
    changeType: DataImportRowChangeType;
    /**
     * 
     * @type {string}
     * @memberof DataImportRow
     */
    dataImportId: string;
    /**
     * 
     * @type {string}
     * @memberof DataImportRow
     */
    id: string;
}



/**
 * Check if a given object implements the DataImportRow interface.
 */
export function instanceOfDataImportRow(value: object): value is DataImportRow {
    if (!('rawData' in value) || value['rawData'] === undefined) return false;
    if (!('changeType' in value) || value['changeType'] === undefined) return false;
    if (!('dataImportId' in value) || value['dataImportId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function DataImportRowFromJSON(json: any): DataImportRow {
    return DataImportRowFromJSONTyped(json, false);
}

export function DataImportRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataImportRow {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
        'rawData': json['rawData'],
        'changeType': DataImportRowChangeTypeFromJSON(json['changeType']),
        'dataImportId': json['dataImportId'],
        'id': json['id'],
    };
}

export function DataImportRowToJSON(value?: DataImportRow | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'error': value['error'],
        'rawData': value['rawData'],
        'changeType': DataImportRowChangeTypeToJSON(value['changeType']),
        'dataImportId': value['dataImportId'],
        'id': value['id'],
    };
}

